import React from "react";

import { colors } from "@zapalacorp/tokens";

import StyledBadge from "../StyledBadge";
import { TickCircle, UserOctagon } from "iconsax-react";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckIcon from "@mui/icons-material/Check";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
  style?: React.CSSProperties;
};

const BadgeJobStatus = (props: Props) => {
  const { value, className, dataCy, style } = props;

  const renderBadge = (
    backgroundColor: string,
    textColor: string,
    value?: string,
    leftIcon?: React.ReactNode
  ) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
          style={style}
          leftIcon={leftIcon}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase?.()) {
    case "booked":
      return renderBadge("#eafaf9", "#38CFC4", value);
    case "received":
      return renderBadge("#e7e9fd", "#7E8AF6", value);
    case "packed":
      return renderBadge("#F4EBFF", "#7F56D9", value);
    case "started":
      return renderBadge("#dfe6ec", "#93A9BD", value);
    case "loaded":
    case "partly loaded":
      return renderBadge("#dbf0e1", "#50B56C", value);
    case "unloaded":
      return renderBadge("#ffede6", "#FFAA86", value);
    case "late":
      return renderBadge("#faebeb", "#CF4842", value);
    case "delivered":
      return renderBadge("#eaf5fa", "#38A2CF", value, <CheckIcon sx={{ fontSize: 16 }} />);
    case "finished":
      return renderBadge("#fcf8e9", "#E5CA4F", value);
    case "in transit":
      return renderBadge("#faf1ea", "#CF7738", value);
    case "in progress":
      return renderBadge("#faf1ea", "#CF7738", value);
    case "cancelled":
      return renderBadge("#faebeb", "#CF4842", value);
    case "planned":
      return renderBadge("#eaf5fa", "#308CDB", value);
    case "agent":
      return renderBadge("#FEE4E2", "#7A271A", value, <UserOctagon size={16} />);
    case "transshipped":
      return renderBadge("#E0F2FE", "#0086C9", value);
    case "placeholder":
      return renderBadge(colors.purple50, colors.purple500, value);
    case "pending accept":
      return renderBadge(
        colors.purple100,
        colors.purple600,
        value,
        <DescriptionIcon sx={{ fontSize: 16 }} />
      );
    case "registered":
      return renderBadge(colors.blueLight100, colors.blueLight600, value, <TickCircle size={16} />);
    default:
      return renderBadge("#eafaf9", "#38CFC4", value);
  }
};

export default BadgeJobStatus;
